import { render, staticRenderFns } from "./ReturnAbuseReport.vue?vue&type=template&id=6c0199a6&scoped=true"
import script from "./ReturnAbuseReport.vue?vue&type=script&lang=js"
export * from "./ReturnAbuseReport.vue?vue&type=script&lang=js"
import style0 from "./ReturnAbuseReport.vue?vue&type=style&index=0&id=6c0199a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0199a6",
  null
  
)

export default component.exports